import * as fromPotential from '../actions/potential.action';
import {User} from '../../../users/user';


export interface PotentialState {
  users: User[];
  user?: User;
  loading: boolean;
  loaded: boolean;
  error: string;
}

export const initialState = {
  users: null,
  loading: true,
  loaded: false,
  error: null,
  user: null,
};

export function reducer(state = initialState, action: fromPotential.PotentialAction): PotentialState {
  switch (action.type) {
    case fromPotential.GET_ALL_POTENTIALS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromPotential.GET_ALL_POTENTIALS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: action.payload,
        error: null
      };
    }
    case fromPotential.GET_ALL_POTENTIALS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        user: null,
        error: action.payload
      };
    }
    case fromPotential.GET_POTENTIAL: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    }
    case fromPotential.GET_POTENTIAL_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.payload,
        error: null
      };
    }
    case fromPotential.GET_POTENTIAL_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        user: null,
        error: action.payload
      };
    }
    case fromPotential.APPROVE_POTENTIAL: {
      return {
        ...state,

        loading: true,
        loaded: false,
      };
    }
    case fromPotential.REJECT_POTENTIAL: {
      return {
        ...state,

        loading: true,
        loaded: false,
      };
    }
    case fromPotential.UPDATE_POTENTIAL_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
    case fromPotential.UPDATE_POTENTIAL_SUCCESS: {
      if (state.users) {
        state.users.filter((user, index) => {
          if (user.id === action.payload.id) {
            state.users[index] = action.payload;
          }
        });
      }
      return {
        ...state,
        user: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/store/reducers/potential.reducer.ts